import { useUserManagementTableColumns } from '@/screens/UserManagement/hooks/useUserManagementTableColumns';
import type { UserDto } from '@api/WhisApi/generated/model/userDto';
import { Table } from '@components/Table/Table';
import { useAppTranslation } from '@hooks/useAppTranslation';
import type { SortingState } from '@tanstack/react-table';

interface UserManagementTableProps {
  users: UserDto[];
  onEdit?: (user: UserDto) => void;
  onDelete?: (user: UserDto) => void;
  onSortingChange?: (sorting: SortingState) => void;
}

export const UserManagementTable = ({
  users,
  onEdit,
  onDelete,
  onSortingChange,
}: UserManagementTableProps): React.ReactNode => {
  const { t } = useAppTranslation();
  const columns = useUserManagementTableColumns({ onEdit, onDelete });

  return (
    <Table<UserDto>
      data={users}
      idKey="id"
      columnDefs={columns}
      onSortingChange={onSortingChange}
      emptyMessage={t('userManagement.empty.list')}
      multiSort={false}
    />
  );
};
